export default {
    title: 'Сброс пароля',
    title_submitted: 'Готово! Войдите, чтобы продолжить.',
    title_expired: 'Запрос истек',
    subtitle: 'Пожалуйста, введите ваш новый пароль.',
    buttons: {
        go_to_login: 'Перейти к входу',
    },
    notifications: {
        password_changed: 'Ваш пароль был изменен',
        request_expired: 'Ваш запрос истек. Пожалуйста, попробуйте снова!',
    },
}
